import { createSystem, defaultConfig } from '@chakra-ui/react'

import { globalCss } from './globalCss'
import { recipes } from './recipes'
import { semanticTokens } from './semantic-tokens'
import { slotRecipes } from './slot-recipes'
import { tokens } from './tokens'

export const system = createSystem(defaultConfig, {
  globalCss,
  theme: {
    tokens,
    semanticTokens,
    recipes,
    slotRecipes,
  },
})
